export class APIData{
   
    apiToCall :number
    additionalData:any[]
    parentFolderId : number
}